import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { persistStore } from "redux-persist";

import snackSlice from "./slices/snack.slice";
import authSlice from "./slices/auth.slice";
import preflopSlice from "./slices/preflop/preflop.slice.js";
import subscriptionModalSlice from "./slices/modal/subscription.modal.slice.js";
import flopSlice from "./slices/flop/flop.slice.js";
import turnSlice from "./slices/turn/turn.slice.js";
import riverSlice from "./slices/river/river.slice.js";
import betSlice from "./slices/bet/bet.slice.js";

import { loginService } from "./services/auth/login.service";
import { signupService } from "./services/auth/signup.service";
import { forgetPasswordService } from "./services/auth/forgetpwd.service";
import { getUserByIdService } from "./services/auth/getUserById.service";
import { resetPasswordService } from "./services/auth/resetPassword.service";
import { changePasswordService } from "./services/auth/changepwd.service";
import { solveService } from "./services/solve/solve.service";
import { updateProfileService } from "./services/update profile/updateprofile.service";
import { playingCardsService } from "./services/playing cards/getcards.service";
import { matrixService } from "./services/matrix/matrix.service";
import { cardPairsService } from "./services/flop/cardpairs.service";
import { flopResultService } from "./services/flop/calculateflopresult.service";
import { rangeAnalysisService } from "./services/flop/range.service";
import { sheetUploadService } from "./services/sheet/sheetupload.service";

// Stripe subscription service
import {
  stripeApi,
  useCreatePaymentIntentMutation,
  useCreateSubscriptionMutation,
  useCancelSubscriptionMutation
} from "./services/subscription/subscription.service";
import { trialStatusService } from "./services/subscription/trialStatus.service";

// Redux-persist actions
import { FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from "redux-persist";

const reducers = combineReducers({
  [loginService.reducerPath]: loginService.reducer,
  [signupService.reducerPath]: signupService.reducer,
  [forgetPasswordService.reducerPath]: forgetPasswordService.reducer,
  [getUserByIdService.reducerPath]: getUserByIdService.reducer,
  [resetPasswordService.reducerPath]: resetPasswordService.reducer,
  [changePasswordService.reducerPath]: changePasswordService.reducer,
  [solveService.reducerPath]: solveService.reducer,
  [updateProfileService.reducerPath]: updateProfileService.reducer,
  [playingCardsService.reducerPath]: playingCardsService.reducer,
  [matrixService.reducerPath]: matrixService.reducer,
  [cardPairsService.reducerPath]: cardPairsService.reducer,
  [flopResultService.reducerPath]: flopResultService.reducer,
  [rangeAnalysisService.reducerPath]: rangeAnalysisService.reducer,
  [sheetUploadService.reducerPath]: sheetUploadService.reducer,
  [stripeApi.reducerPath]: stripeApi.reducer, // Stripe subscription API
  [trialStatusService.reducerPath]: trialStatusService.reducer, // Trial status API
  authSlice,
  snackSlice,
  preflopSlice,
  subscriptionModalSlice,
  flopSlice,
  turnSlice,
  riverSlice,
  betSlice,
});

const persistConfig = {
  key: "root",
  version: 1,
  storage,
  whitelist: ["authSlice"], // persist auth only
};

const persistedReducer = persistReducer(persistConfig, reducers);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: { ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER] },
    }).concat(
      loginService.middleware,
      signupService.middleware,
      forgetPasswordService.middleware,
      getUserByIdService.middleware,
      resetPasswordService.middleware,
      changePasswordService.middleware,
      solveService.middleware,
      updateProfileService.middleware,
      playingCardsService.middleware,
      matrixService.middleware,
      cardPairsService.middleware,
      flopResultService.middleware,
      rangeAnalysisService.middleware,
      sheetUploadService.middleware,
      stripeApi.middleware, // Stripe API middleware
      trialStatusService.middleware // Trial status API middleware
    ),
});

export default store;
export let persistore = persistStore(store);

// Optionally, you can export the Stripe hooks here if you want to import them from store
export {
  useCreatePaymentIntentMutation,
  useCreateSubscriptionMutation,
  useCancelSubscriptionMutation
};
